import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchModes } from '@/lib/api';
import BreathingCue from '@/components/BreathingCue';
import { getSettings } from '@/lib/storage';
import EXHALE from '@/lib/testIds';

export default function Modes() {
  const [modes, setModes] = useState([]);
  const [loading, setLoading] = useState(true);
  const settings = getSettings();

  useEffect(() => {
    let active = true;
    fetchModes()
      .then((data) => { if (active) setModes(data); })
      .catch(() => { if (active) setModes([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return (
    <section
      data-testid={EXHALE.modesRoot}
      className="relative min-h-[calc(100vh-6rem)] px-6 sm:px-12 py-16 sm:py-20"
    >
      <BreathingCue active={settings.breathing} dimmed />

      <div className="relative z-10 mx-auto max-w-2xl">
        <p className="eyebrow">pick how you'd like to arrive</p>
        <h2 className="mt-4 font-serif font-light text-3xl sm:text-4xl tracking-tight">
          Modes
        </h2>
        <p className="mt-4 max-w-lg text-muted-foreground">
          Each one is just a different doorway into the same quiet room.
          Nothing here is right or wrong.
        </p>

        <ul className="mt-12 flex flex-col">
          {loading && (
            <li className="py-6 text-sm text-muted-foreground">loading quietly…</li>
          )}
          {!loading && modes.map((m, i) => (
            <li key={m.id} className="group">
              {i > 0 && <div className="quiet-dash" />}
              <Link
                to={`/session/${m.id}`}
                data-testid={EXHALE.modeCard(m.id)}
                className="block py-7 sm:py-8 transition-opacity duration-500 opacity-90 hover:opacity-100"
              >
                <div className="flex flex-col gap-1.5 sm:flex-row sm:items-baseline sm:justify-between sm:gap-8">
                  <span className="font-serif text-2xl sm:text-3xl font-light tracking-tight">
                    {m.name}
                  </span>
                  <span className="text-xs tracking-[0.18em] uppercase text-sage">
                    enter →
                  </span>
                </div>
                <p className="mt-2 text-base sm:text-lg leading-relaxed text-foreground/70">
                  {m.subtitle}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
